"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entities = void 0;
const tslib_1 = require("tslib");
const acl_actions_entity_1 = require("./acl-actions.entity");
const acl_categories_entity_1 = require("./acl-categories.entity");
const acl_category_action_api_map_entity_1 = require("./acl-category-action-api-map.entity");
const acl_category_action_map_entity_1 = require("./acl-category-action-map.entity");
const address_entity_1 = require("./address.entity");
const archived_file_upload_entity_1 = require("./archived-file-upload.entity");
const broker_address_entity_1 = require("./broker-address.entity");
const broker_contact_entity_1 = require("./broker-contact.entity");
const broker_entity_1 = require("./broker.entity");
const child_details_entity_1 = require("./child-details.entity");
const city_entity_1 = require("./city.entity");
const company_contact_entity_1 = require("./company-contact.entity");
const company_detail_entity_1 = require("./company-detail.entity");
const company_document_map_entity_1 = require("./company-document-map.entity");
const company_gst_detail_entity_1 = require("./company-gst-detail.entity");
const company_address_entity_1 = require("./company.address.entity");
const company_entity_1 = require("./company.entity");
const contact_address_entity_1 = require("./contact-address.entity");
const contact_communication_details_entity_1 = require("./contact-communication-details.entity");
const contact_details_entity_1 = require("./contact-details.entity");
const contact_document_map_entity_1 = require("./contact-document-map.entity");
const contact_entity_1 = require("./contact.entity");
const country_entity_1 = require("./country.entity");
const currency_entity_1 = require("./currency.entity");
const data_validation_entity_1 = require("./data-validation.entity");
const department_entity_1 = require("./department.entity");
const designation_entity_1 = require("./designation.entity");
const employee_entity_1 = require("./employee.entity");
const employee_hierarchy_entity_1 = require("./employee_hierarchy.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const final_negotiation_meeting_summary_entity_1 = require("./final-negotiation-meeting-summary.entity");
const final_negotiation_participants_entity_1 = require("./final-negotiation-participants.entity");
const group_comapny_map_entity_1 = require("./group-comapny-map.entity");
const hand_over_meet_entity_1 = require("./hand-over-meet.entity");
const held_cover_note_document_map_entity_1 = require("./held-cover-note-document-map.entity");
const industry_segment_entity_1 = require("./industry-segment.entity");
const insurer_address_entity_1 = require("./insurer-address.entity");
const insurer_contact_entity_1 = require("./insurer-contact.entity");
const insurer_participation_entity_1 = require("./insurer-participation.entity");
const insurer_entity_1 = require("./insurer.entity");
const kdm_meeting_document_map_entity_1 = require("./kdm-meeting-document-map.entity");
const kdm_meeting_entity_1 = require("./kdm-meeting.entity");
const knowledge_central_entity_1 = require("./knowledge-central.entity");
const localization_company_regulatory_field_entity_1 = require("./localization-company-regulatory-field.entity");
const localization_country_entity_1 = require("./localization-country.entity");
const localization_regulatory_fields_country_map_entity_1 = require("./localization-regulatory-fields-country-map.entity");
const look_up_entity_1 = require("./look-up.entity");
const meeting_document_map_entity_1 = require("./meeting-document-map.entity");
const meeting_participants_entity_1 = require("./meeting-participants.entity");
const meeting_entity_1 = require("./meeting.entity");
const mstr_activity_entity_1 = require("./mstr-activity.entity");
const mstr_cover_template_entity_1 = require("./mstr-cover-template.entity");
const mstr_cover_entity_1 = require("./mstr-cover.entity");
const mstr_stage_activity_template_entity_1 = require("./mstr-stage-activity-template.entity");
const mstr_stage_entity_1 = require("./mstr-stage.entity");
const note_document_map_entity_1 = require("./note-document-map.entity");
const note_entity_1 = require("./note.entity");
const notification_event_parameter_mapping_entity_1 = require("./notification-event-parameter-mapping.entity");
const notification_event_template_mapping_entity_1 = require("./notification-event-template-mapping.entity");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
const notification_in_app_entity_1 = require("./notification-in-app.entity");
const notification_log_entity_1 = require("./notification-log.entity");
const notification_template_entity_1 = require("./notification-template.entity");
const notification_parameter_entity_1 = require("./notification_parameter.entity");
const notififcation_log_receiver_record_entity_1 = require("./notififcation-log-receiver-record.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const opportunity_activity_participants_entity_1 = require("./opportunity-activity-participants.entity");
const opportunity_broking_slip_activity_document_map_entity_1 = require("./opportunity-broking-slip-activity-document-map.entity");
const opportunity_broking_slip_version_cover_map_details_entity_1 = require("./opportunity-broking-slip-version-cover-map-details.entity");
const opportunity_broking_slip_version_entity_1 = require("./opportunity-broking-slip-version.entity");
const opportunity_challenges_entity_1 = require("./opportunity-challenges.entity");
const opportunity_claim_experience_entity_1 = require("./opportunity-claim-experience.entity");
const opportunity_competitor_entity_1 = require("./opportunity-competitor.entity");
const opportunity_contact_map_entity_1 = require("./opportunity-contact-map.entity");
const opportunity_cover_entity_1 = require("./opportunity-cover.entity");
const opportunity_data_validation_document_map_entity_1 = require("./opportunity-data-validation-document-map.entity");
const opportunity_document_entity_1 = require("./opportunity-document.entity");
const opportunity_final_negotiation_qcr_variation_entity_1 = require("./opportunity-final-negotiation-qcr-variation.entity");
const opportunity_final_negotiation_quote_cover_detail_entity_1 = require("./opportunity-final-negotiation-quote-cover-detail.entity");
const opportunity_final_negotiation_quote_documents_entity_1 = require("./opportunity-final-negotiation-quote-documents.entity");
const opportunity_final_negotiation_service_level_agreement_entity_1 = require("./opportunity-final-negotiation-service-level-agreement.entity");
const opportunity_final_negotiation_sharing_detail_entity_1 = require("./opportunity-final-negotiation-sharing-detail.entity");
const opportunity_final_negotiation_tax_map_entity_1 = require("./opportunity-final-negotiation-tax-map.entity");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
const opportunity_held_cover_note_entity_1 = require("./opportunity-held-cover-note.entity");
const opportunity_lost_entity_1 = require("./opportunity-lost.entity");
const opportunity_mandate_details_contact_map_entity_1 = require("./opportunity-mandate-details-contact-map.entity");
const opportunity_mandate_details_document_map_entity_1 = require("./opportunity-mandate-details-document-map.entity");
const opportunity_mandate_details_entry_entity_1 = require("./opportunity-mandate-details-entry.entity");
const opportunity_placement_slip_cd_detail_entity_1 = require("./opportunity-placement-slip-cd-detail.entity");
const opportunity_placement_slip_cover_detail_entity_1 = require("./opportunity-placement-slip-cover-detail.entity");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
const opportunity_placement_slip_installment_detail_entity_1 = require("./opportunity-placement-slip-installment-detail.entity");
const opportunity_placement_slip_insurer_map_entity_1 = require("./opportunity-placement-slip-insurer-map.entity");
const opportunity_placement_slip_sharing_detail_entity_1 = require("./opportunity-placement-slip-sharing-detail.entity");
const opportunity_placement_slip_tpa_map_entity_1 = require("./opportunity-placement-slip-tpa-map.entity");
const opportunity_policy_confirmation_entity_1 = require("./opportunity-policy-confirmation.entity");
const opportunity_policy_docket_entity_1 = require("./opportunity-policy-docket.entity");
const opportunity_policy_hard_copy_entity_1 = require("./opportunity-policy-hard-copy.entity");
const opportunity_premium_calculation_cover_details_entity_1 = require("./opportunity-premium-calculation-cover-details.entity");
const opportunity_premium_calculation_entity_1 = require("./opportunity-premium-calculation.entity");
const opportunity_previous_mediator_details_entity_1 = require("./opportunity-previous-mediator-details.entity");
const opportunity_previous_placement_details_entity_1 = require("./opportunity-previous-placement-details.entity");
const opportunity_quote_comparison_report_document_map_entity_1 = require("./opportunity-quote-comparison-report-document-map.entity");
const opportunity_quote_comparison_report_entity_1 = require("./opportunity-quote-comparison-report.entity");
const opportunity_quote_document_map_entity_1 = require("./opportunity-quote-document-map.entity");
const opportunity_quote_entry_cover_detail_entity_1 = require("./opportunity-quote-entry-cover-detail.entity");
const opportunity_quote_entry_document_map_entity_1 = require("./opportunity-quote-entry-document-map.entity");
const opportunity_quote_entry_tax_map_entity_1 = require("./opportunity-quote-entry-tax-map.entity");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
const opportunity_quote_entity_1 = require("./opportunity-quote.entity");
const opportunity_rfp_activity_document_map_entity_1 = require("./opportunity-rfp-activity-document-map.entity");
const opportunity_rfp_client_contact_details_entity_1 = require("./opportunity-rfp-client-contact-details.entity");
const opportunity_rfp_client_contact_influencers_entity_1 = require("./opportunity-rfp-client-contact-influencers.entity");
const opportunity_rfp_cover_detail_entity_1 = require("./opportunity-rfp-cover-detail.entity");
const opportunity_rfp_credit_sharing_entity_1 = require("./opportunity-rfp-credit-sharing.entity");
const opportunity_rfp_detail_entity_1 = require("./opportunity-rfp-detail.entity");
const opportunity_rfp_details_entry_doument_map_entity_1 = require("./opportunity-rfp-details-entry-doument-map.entity");
const opportunity_rfp_details_entry_entity_1 = require("./opportunity-rfp-details-entry.entity");
const opportunity_rfp_insurer_detail_entity_1 = require("./opportunity-rfp-insurer-detail.entity");
const opportunity_rfp_tpa_detail_entity_1 = require("./opportunity-rfp-tpa-detail.entity");
const opportunity_risk_locations_entity_1 = require("./opportunity-risk-locations.entity");
const opportunity_entity_1 = require("./opportunity.entity");
const org_branch_entity_1 = require("./org-branch.entity");
const org_vertical_entity_1 = require("./org-vertical.entity");
const organisation_entity_1 = require("./organisation.entity");
const placement_slip_document_map_entity_1 = require("./placement-slip-document-map.entity");
const policy_confirmation_document_map_entity_1 = require("./policy-confirmation-document-map.entity");
const policy_docket_document_map_entity_1 = require("./policy-docket-document-map.entity");
const policy_hard_copy_document_map_entity_1 = require("./policy-hard-copy-document-map.entity");
const policy_entity_1 = require("./policy.entity");
const preferred_insurer_details_entity_1 = require("./preferred-insurer-details.entity");
const preferred_tpa_details_entity_1 = require("./preferred-tpa-details.entity");
const premium_calculation_document_map_entity_1 = require("./premium-calculation-document-map.entity");
const professional_experience_entity_1 = require("./professional-experience.entity");
const qualification_experience_entity_1 = require("./qualification-experience.entity");
const region_entity_1 = require("./region.entity");
const role_acl_category_action_map_entity_1 = require("./role-acl-category-action-map.entity");
const roles_entity_1 = require("./roles.entity");
const state_entity_1 = require("./state.entity");
const task_document_map_entity_1 = require("./task-document-map.entity");
const task_entity_1 = require("./task.entity");
const tpa_address_entity_1 = require("./tpa-address.entity");
const tpa_contact_entity_1 = require("./tpa-contact.entity");
const tpa_entity_1 = require("./tpa.entity");
const user_1 = require("./user");
const user_role_entity_1 = require("./user-role.entity");
const policy_cd_number_map_entity_1 = require("./policy-cd-number-map.entity");
const policy_insurer_map_entity_1 = require("./policy-insurer-map.entity");
const policy_tpa_map_entity_1 = require("./policy-tpa-map.entity");
const policy_covers_map_entity_1 = require("./policy-covers-map.entity");
const policy_premium_installment_schedules_entity_1 = require("./policy-premium-installment-schedules.entity");
tslib_1.__exportStar(require("./acl-actions.entity"), exports);
tslib_1.__exportStar(require("./acl-categories.entity"), exports);
tslib_1.__exportStar(require("./acl-category-action-api-map.entity"), exports);
tslib_1.__exportStar(require("./acl-category-action-map.entity"), exports);
tslib_1.__exportStar(require("./address.entity"), exports);
tslib_1.__exportStar(require("./broker-address.entity"), exports);
tslib_1.__exportStar(require("./broker-contact.entity"), exports);
tslib_1.__exportStar(require("./broker.entity"), exports);
tslib_1.__exportStar(require("./city.entity"), exports);
tslib_1.__exportStar(require("./company-contact.entity"), exports);
tslib_1.__exportStar(require("./company-detail.entity"), exports);
tslib_1.__exportStar(require("./company-document-map.entity"), exports);
tslib_1.__exportStar(require("./company-gst-detail.entity"), exports);
tslib_1.__exportStar(require("./company.address.entity"), exports);
tslib_1.__exportStar(require("./company.entity"), exports);
tslib_1.__exportStar(require("./contact-address.entity"), exports);
tslib_1.__exportStar(require("./contact-communication-details.entity"), exports);
tslib_1.__exportStar(require("./contact-details.entity"), exports);
tslib_1.__exportStar(require("./contact-document-map.entity"), exports);
tslib_1.__exportStar(require("./contact.entity"), exports);
tslib_1.__exportStar(require("./country.entity"), exports);
tslib_1.__exportStar(require("./currency.entity"), exports);
tslib_1.__exportStar(require("./data-validation.entity"), exports);
tslib_1.__exportStar(require("./department.entity"), exports);
tslib_1.__exportStar(require("./designation.entity"), exports);
tslib_1.__exportStar(require("./employee.entity"), exports);
tslib_1.__exportStar(require("./employee_hierarchy.entity"), exports);
tslib_1.__exportStar(require("./file-upload.entity"), exports);
tslib_1.__exportStar(require("./final-negotiation-meeting-summary.entity"), exports);
tslib_1.__exportStar(require("./final-negotiation-participants.entity"), exports);
tslib_1.__exportStar(require("./group-comapny-map.entity"), exports);
tslib_1.__exportStar(require("./hand-over-meet.entity"), exports);
tslib_1.__exportStar(require("./held-cover-note-document-map.entity"), exports);
tslib_1.__exportStar(require("./industry-segment.entity"), exports);
tslib_1.__exportStar(require("./insurer-address.entity"), exports);
tslib_1.__exportStar(require("./insurer-contact.entity"), exports);
tslib_1.__exportStar(require("./insurer-participation.entity"), exports);
tslib_1.__exportStar(require("./insurer.entity"), exports);
tslib_1.__exportStar(require("./kdm-meeting.entity"), exports);
tslib_1.__exportStar(require("./knowledge-central.entity"), exports);
tslib_1.__exportStar(require("./look-up.entity"), exports);
tslib_1.__exportStar(require("./meeting-document-map.entity"), exports);
tslib_1.__exportStar(require("./meeting-participants.entity"), exports);
tslib_1.__exportStar(require("./meeting.entity"), exports);
tslib_1.__exportStar(require("./mstr-activity.entity"), exports);
tslib_1.__exportStar(require("./mstr-cover-template.entity"), exports);
tslib_1.__exportStar(require("./mstr-cover.entity"), exports);
tslib_1.__exportStar(require("./mstr-stage-activity-template.entity"), exports);
tslib_1.__exportStar(require("./mstr-stage.entity"), exports);
tslib_1.__exportStar(require("./note-document-map.entity"), exports);
tslib_1.__exportStar(require("./note.entity"), exports);
tslib_1.__exportStar(require("./notification-event-parameter-mapping.entity"), exports);
tslib_1.__exportStar(require("./notification-event-template-mapping.entity"), exports);
tslib_1.__exportStar(require("./notification-event-type.entity"), exports);
tslib_1.__exportStar(require("./notification-in-app.entity"), exports);
tslib_1.__exportStar(require("./notification-log.entity"), exports);
tslib_1.__exportStar(require("./notification-template.entity"), exports);
tslib_1.__exportStar(require("./notification_parameter.entity"), exports);
tslib_1.__exportStar(require("./notififcation-log-receiver-record.entity"), exports);
tslib_1.__exportStar(require("./opportunity-activity-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-activity-participants.entity"), exports);
tslib_1.__exportStar(require("./opportunity-broking-slip-activity-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-broking-slip-version-cover-map-details.entity"), exports);
tslib_1.__exportStar(require("./opportunity-broking-slip-version.entity"), exports);
tslib_1.__exportStar(require("./opportunity-challenges.entity"), exports);
tslib_1.__exportStar(require("./opportunity-claim-experience.entity"), exports);
tslib_1.__exportStar(require("./opportunity-competitor.entity"), exports);
tslib_1.__exportStar(require("./opportunity-contact-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-cover.entity"), exports);
tslib_1.__exportStar(require("./opportunity-data-validation-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-document.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-qcr-variation.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-quote-cover-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-quote-documents.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-service-level-agreement.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-sharing-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation-tax-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-final-negotiation.entity"), exports);
tslib_1.__exportStar(require("./opportunity-held-cover-note.entity"), exports);
tslib_1.__exportStar(require("./opportunity-lost.entity"), exports);
tslib_1.__exportStar(require("./opportunity-mandate-details-contact-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-mandate-details-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-mandate-details-entry.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-cd-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-cover-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-generation.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-installment-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-insurer-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-sharing-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-placement-slip-tpa-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-policy-confirmation.entity"), exports);
tslib_1.__exportStar(require("./opportunity-policy-docket.entity"), exports);
tslib_1.__exportStar(require("./opportunity-policy-hard-copy.entity"), exports);
tslib_1.__exportStar(require("./opportunity-premium-calculation-cover-details.entity"), exports);
tslib_1.__exportStar(require("./opportunity-premium-calculation.entity"), exports);
tslib_1.__exportStar(require("./opportunity-previous-mediator-details.entity"), exports);
tslib_1.__exportStar(require("./opportunity-previous-placement-details.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-comparison-report-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-comparison-report.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-entry-cover-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-entry-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-entry.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-activity-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-client-contact-details.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-client-contact-influencers.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-cover-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-credit-sharing.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-details-entry-doument-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-details-entry.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-insurer-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-rfp-tpa-detail.entity"), exports);
tslib_1.__exportStar(require("./opportunity-risk-locations.entity"), exports);
tslib_1.__exportStar(require("./opportunity.entity"), exports);
tslib_1.__exportStar(require("./org-branch.entity"), exports);
tslib_1.__exportStar(require("./org-vertical.entity"), exports);
tslib_1.__exportStar(require("./organisation.entity"), exports);
tslib_1.__exportStar(require("./placement-slip-document-map.entity"), exports);
tslib_1.__exportStar(require("./policy-confirmation-document-map.entity"), exports);
tslib_1.__exportStar(require("./policy-docket-document-map.entity"), exports);
tslib_1.__exportStar(require("./policy-hard-copy-document-map.entity"), exports);
tslib_1.__exportStar(require("./policy.entity"), exports);
tslib_1.__exportStar(require("./preferred-insurer-details.entity"), exports);
tslib_1.__exportStar(require("./preferred-tpa-details.entity"), exports);
tslib_1.__exportStar(require("./premium-calculation-document-map.entity"), exports);
tslib_1.__exportStar(require("./professional-experience.entity"), exports);
tslib_1.__exportStar(require("./qualification-experience.entity"), exports);
tslib_1.__exportStar(require("./region.entity"), exports);
tslib_1.__exportStar(require("./role-acl-category-action-map.entity"), exports);
tslib_1.__exportStar(require("./roles.entity"), exports);
tslib_1.__exportStar(require("./state.entity"), exports);
tslib_1.__exportStar(require("./task-document-map.entity"), exports);
tslib_1.__exportStar(require("./task.entity"), exports);
tslib_1.__exportStar(require("./tpa-address.entity"), exports);
tslib_1.__exportStar(require("./tpa-contact.entity"), exports);
tslib_1.__exportStar(require("./tpa.entity"), exports);
tslib_1.__exportStar(require("./user"), exports);
tslib_1.__exportStar(require("./user-role.entity"), exports);
tslib_1.__exportStar(require("./localization-company-regulatory-field.entity"), exports);
tslib_1.__exportStar(require("./localization-country.entity"), exports);
tslib_1.__exportStar(require("./localization-regulatory-fields-country-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-entry-document-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote-entry-tax-map.entity"), exports);
tslib_1.__exportStar(require("./opportunity-quote.entity"), exports);
tslib_1.__exportStar(require("./archived-file-upload.entity"), exports);
tslib_1.__exportStar(require("./policy-cd-number-map.entity"), exports);
tslib_1.__exportStar(require("./policy-insurer-map.entity"), exports);
tslib_1.__exportStar(require("./policy-tpa-map.entity"), exports);
tslib_1.__exportStar(require("./policy-covers-map.entity"), exports);
tslib_1.__exportStar(require("./policy-premium-installment-schedules.entity"), exports);
exports.entities = [
    opportunity_final_negotiation_quote_documents_entity_1.OpportunityFinalNegotiationQuoteDocuments,
    opportunity_final_negotiation_quote_cover_detail_entity_1.OpportunityFinalNegotiationQuoteCoverDetail,
    user_1.User,
    look_up_entity_1.LookUp,
    organisation_entity_1.Organisation,
    designation_entity_1.Designation,
    industry_segment_entity_1.IndustrySegment,
    org_vertical_entity_1.OrgVertical,
    org_branch_entity_1.OrgBranch,
    department_entity_1.Department,
    contact_entity_1.Contact,
    address_entity_1.Address,
    region_entity_1.Region,
    country_entity_1.Country,
    city_entity_1.City,
    state_entity_1.State,
    tpa_entity_1.Tpa,
    tpa_address_entity_1.TpaAddress,
    tpa_contact_entity_1.TpaContact,
    contact_address_entity_1.ContactAddress,
    company_contact_entity_1.CompanyContactMap,
    insurer_entity_1.Insurer,
    insurer_address_entity_1.InsurerAddress,
    insurer_contact_entity_1.InsureContact,
    employee_entity_1.Employee,
    company_entity_1.Company,
    policy_entity_1.Policy,
    company_address_entity_1.CompanyAddress,
    company_detail_entity_1.CompanyDetail,
    contact_details_entity_1.ContactDetails,
    qualification_experience_entity_1.QualificationExperience,
    professional_experience_entity_1.ProfessionalExperience,
    user_role_entity_1.UserRole,
    roles_entity_1.Role,
    role_acl_category_action_map_entity_1.RoleAclCategoryActionMap,
    acl_categories_entity_1.AclCategory,
    acl_actions_entity_1.AclAction,
    acl_category_action_map_entity_1.AclCategoryActionMap,
    company_gst_detail_entity_1.StateGstDetail,
    file_upload_entity_1.FileUpload,
    company_document_map_entity_1.CompanyDocMap,
    group_comapny_map_entity_1.GroupCompanyMap,
    contact_document_map_entity_1.ContactDocMap,
    contact_communication_details_entity_1.ContactCommunicationDetails,
    broker_entity_1.Broker,
    broker_address_entity_1.BrokerAddress,
    opportunity_entity_1.Opportunity,
    opportunity_document_entity_1.OpportunityDocuments,
    opportunity_risk_locations_entity_1.OpportunityRiskLocations,
    opportunity_challenges_entity_1.OpportunityChallenges,
    opportunity_competitor_entity_1.OpportunityCompetitors,
    opportunity_claim_experience_entity_1.OpportunityClaimExperiences,
    broker_contact_entity_1.BrokerContact,
    child_details_entity_1.ChildDetails,
    currency_entity_1.Currency,
    opportunity_previous_placement_details_entity_1.OpportunityPreviousPlacementDetails,
    opportunity_previous_mediator_details_entity_1.OpportunityPreviousMediatorDetails,
    opportunity_contact_map_entity_1.OpportunityContactMap,
    opportunity_lost_entity_1.OpportunityLost,
    mstr_cover_entity_1.MstrCover,
    mstr_cover_template_entity_1.MstrCoverTemplate,
    opportunity_cover_entity_1.OpportunityCoverMap,
    final_negotiation_meeting_summary_entity_1.FinalNegotiationMeetingSummary,
    insurer_participation_entity_1.InsurerParticipants,
    opportunity_quote_entity_1.OpportunityQuote,
    mstr_activity_entity_1.MstrActivity,
    mstr_stage_entity_1.MstrStage,
    mstr_stage_activity_template_entity_1.MstrStageActivityTemplate,
    opportunity_activity_map_entity_1.OpportunityActivityMap,
    opportunity_activity_participants_entity_1.OpportunityActivityParticipants,
    meeting_entity_1.Meeting,
    task_entity_1.Task,
    task_document_map_entity_1.TaskDocumentMap,
    meeting_participants_entity_1.MeetingParticipantMap,
    note_entity_1.Note,
    note_document_map_entity_1.NoteDocumentMap,
    meeting_document_map_entity_1.MeetingDocumentMap,
    final_negotiation_participants_entity_1.FinalNegotiationParticipant,
    data_validation_entity_1.DataValidation,
    kdm_meeting_document_map_entity_1.KdmMeetingDocumentMap,
    kdm_meeting_entity_1.KdmMeeting,
    opportunity_premium_calculation_entity_1.OpportunityPremiumCalculation,
    opportunity_mandate_details_document_map_entity_1.OpportunityMandateDetailsDocumentMap,
    opportunity_mandate_details_entry_entity_1.OpportunityMandateDetailsEntry,
    opportunity_mandate_details_contact_map_entity_1.OpportunityMandateDetailsContactMap,
    opportunity_rfp_cover_detail_entity_1.OpportunityRfpCoverDetail,
    premium_calculation_document_map_entity_1.OpportunityPremiumCalculationDocumentMap,
    opportunity_held_cover_note_entity_1.OpportunityHeldCoverNote,
    held_cover_note_document_map_entity_1.HeldCoverNoteDocumentMap,
    opportunity_data_validation_document_map_entity_1.OpportunityDataValidationDocumentMap,
    opportunity_rfp_detail_entity_1.OpportunityRfpDetail,
    opportunity_rfp_activity_document_map_entity_1.OpportunityRfpActivityDocumentMap,
    opportunity_policy_confirmation_entity_1.OpportunityPolicyConfirmation,
    policy_confirmation_document_map_entity_1.PolicyConfirmationDocumentMap,
    opportunity_policy_hard_copy_entity_1.OpportunityPolicyHardCopy,
    policy_hard_copy_document_map_entity_1.PolicyHardCopyDocumentMap,
    knowledge_central_entity_1.KnowledgeCentral,
    opportunity_quote_entry_entity_1.OpportunityQuoteEntry,
    opportunity_quote_entry_document_map_entity_1.OpportunityQuoteEntryDocumentMap,
    opportunity_policy_docket_entity_1.OpportunityPolicyDocket,
    policy_docket_document_map_entity_1.PolicyDocketDocumentMap,
    opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration,
    opportunity_placement_slip_tpa_map_entity_1.OpportunityPlacementSlipTpaMap,
    opportunity_placement_slip_insurer_map_entity_1.OpportunityPlacementSlipInsurerMap,
    opportunity_placement_slip_sharing_detail_entity_1.OpportunityPlacementSlipSharingDetail,
    opportunity_placement_slip_cd_detail_entity_1.OpportunityPlacementSlipCDDetail,
    opportunity_placement_slip_cover_detail_entity_1.OpportunityPlacementSlipCoverDetail,
    placement_slip_document_map_entity_1.OpportunityPlacementSlipDocumentMap,
    opportunity_placement_slip_installment_detail_entity_1.OpportunityPlacementSlipInstallementDetail,
    preferred_tpa_details_entity_1.PreferredTpaDetails,
    preferred_insurer_details_entity_1.PreferredInsurerDetails,
    opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails,
    opportunity_broking_slip_version_cover_map_details_entity_1.BrokingSlipVersionCoverDetails,
    opportunity_quote_entry_cover_detail_entity_1.OpportunityQuoteCoverDetail,
    opportunity_quote_entry_tax_map_entity_1.OpportunityQuoteTaxMap,
    opportunity_quote_document_map_entity_1.OpportunityQuoteDocumentMap,
    hand_over_meet_entity_1.OpportunityHandOverMeet,
    acl_category_action_api_map_entity_1.AclCategoryActionApiMap,
    employee_hierarchy_entity_1.EmployeeHierarchy,
    opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry,
    opportunity_rfp_tpa_detail_entity_1.OpportunityRfpTpaDetail,
    opportunity_rfp_insurer_detail_entity_1.OpportunityRfpInsurerDetail,
    opportunity_rfp_client_contact_details_entity_1.OpportunityRfpClientContactDetail,
    opportunity_rfp_client_contact_influencers_entity_1.OpportunityRfpClientContactInfluencers,
    opportunity_rfp_credit_sharing_entity_1.OpportunityRfpCreditSharing,
    opportunity_rfp_details_entry_doument_map_entity_1.OpportunityRfpDetailsEntryDocumentMap,
    opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation,
    opportunity_final_negotiation_sharing_detail_entity_1.OpportunityFinalNegotiationSharingDetail,
    opportunity_final_negotiation_qcr_variation_entity_1.OpportunityFinalNegotiationQcrVariation,
    opportunity_final_negotiation_service_level_agreement_entity_1.OpportunityFinalNegotiationServiceLevelAgreement,
    opportunity_final_negotiation_tax_map_entity_1.OpportunityFinalNegotiationTaxMap,
    notification_event_type_entity_1.NotificationEventType,
    notification_template_entity_1.NotificationTemplate,
    notification_event_parameter_mapping_entity_1.NotificationEventParameterMapping,
    notification_parameter_entity_1.NotificationParameter,
    notification_event_template_mapping_entity_1.NotificationEventTemplateMapping,
    notification_log_entity_1.NotificationLog,
    notification_in_app_entity_1.NotificationInApp,
    notififcation_log_receiver_record_entity_1.NotificationLogReceiverRecord,
    opportunity_premium_calculation_cover_details_entity_1.OpportunityPremiumCoverDetail,
    opportunity_broking_slip_activity_document_map_entity_1.OpportunityBrokingSlipActivityDocumentMap,
    opportunity_quote_comparison_report_entity_1.OpportunityQuoteComparisonReport,
    opportunity_quote_comparison_report_document_map_entity_1.OpportunityQuoteComparisonReportDocumentMap,
    localization_company_regulatory_field_entity_1.LocalizationCompanyRegulatoryFields,
    localization_country_entity_1.LocalizationCountry,
    localization_regulatory_fields_country_map_entity_1.LocalizationRegulatoryFieldsCountryMap,
    archived_file_upload_entity_1.ArchivedFileUpload,
    policy_cd_number_map_entity_1.PolicyCdNumberMap,
    policy_covers_map_entity_1.PolicyCoverMap,
    policy_insurer_map_entity_1.PolicyInsurerMap,
    policy_tpa_map_entity_1.PolicyTpaMap,
    policy_premium_installment_schedules_entity_1.PolicyPremiumInstallmentSchedule,
];
